(function () {
  var config = document.currentScript;
  var projectId = config && config.dataset.projectId;
  if (!projectId || !/^[a-z0-9]+$/i.test(projectId)) return;

  var delay = Math.max(4, Math.min(15, Number(config.dataset.delay) || 10)) * 1000;
  var ready = false;
  var requested = false;
  var scheduled = false;
  var intent = false;
  var elapsed = false;
  var stopped = false;
  var featureRequested = false;
  var consent = null;
  var timer;

  function permissions() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
      try {
        return {
          analytics: privacy.analyticsProcessingAllowed() === true,
          marketing: typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed() === true
        };
      } catch (error) {
        return { analytics: false, marketing: false };
      }
    }
    return consent || { analytics: false, marketing: false };
  }

  function updateConsent() {
    if (typeof window.clarity !== 'function') return;
    var allowed = permissions();
    window.clarity('consentv2', {
      ad_Storage: allowed.marketing ? 'granted' : 'denied',
      analytics_Storage: allowed.analytics ? 'granted' : 'denied'
    });
    if (!allowed.analytics && !stopped) {
      window.clarity('stop');
      stopped = true;
    } else if (allowed.analytics && stopped) {
      window.clarity('start');
      stopped = false;
    }
  }

  function start() {
    scheduled = false;
    if (requested || !permissions().analytics) return;
    requested = true;
    clearTimeout(timer);
    var existing = document.querySelector('script[src*="clarity.ms/tag/"]');
    if (existing) {
      updateConsent();
      return;
    }
    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    updateConsent();
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.clarity.ms/tag/' + projectId + '?ref=shopify';
    document.head.appendChild(script);
  }

  function schedule() {
    if (!ready || requested || scheduled || (!intent && !elapsed) || !permissions().analytics) return;
    scheduled = true;
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(start, { timeout: 2000 });
    } else {
      setTimeout(start, 100);
    }
  }

  function loadPrivacy() {
    var shopify = window.Shopify;
    if (shopify && shopify.customerPrivacy) {
      updateConsent();
      schedule();
    } else if (!featureRequested && shopify && typeof shopify.loadFeatures === 'function') {
      featureRequested = true;
      try {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          if (error) featureRequested = false;
          updateConsent();
          schedule();
        });
      } catch (error) {
        featureRequested = false;
      }
    }
  }

  function initialize() {
    ready = true;
    timer = setTimeout(function () {
      elapsed = true;
      schedule();
    }, delay);
    loadPrivacy();
    schedule();
  }

  function onIntent() {
    intent = true;
    loadPrivacy();
    schedule();
  }

  document.addEventListener('pointerdown', onIntent, { once: true, passive: true });
  document.addEventListener('keydown', onIntent, { once: true });
  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = event.detail || {};
    consent = { analytics: detail.analyticsAllowed === true, marketing: detail.marketingAllowed === true };
    updateConsent();
    schedule();
  });
  window.addEventListener('load', loadPrivacy, { once: true });
  window.addEventListener('pageshow', loadPrivacy);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
